import { api } from './apiSlice';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
	isAuthenticated: false,
	jwt: null,
	username: null,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		logOut: (state) => {
			state.isAuthenticated = false;
			state.jwt = null;
			state.isAdmin = false;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			api.endpoints.login.matchFulfilled,
			(state, { payload }) => {
				console.log('Login successful:', payload);
				state.username = payload.user.username;
				state.jwt = payload.jwt;
				state.isAuthenticated = true;
				state.isAdmin = payload.user.isAdmin;
				state.isStaff = payload.user.isStaff;
			}
		);
	},
});

export const { logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth;
